import Breadcrumb from '@/components/base/Breadcrumb';
import { usePageMeta } from '@/hooks/usePageMeta';

const contentScope = [
  { icon: 'ri-film-line', title: '电影资源', desc: '涵盖大陆、美国、韩国、日本、香港等多个地区的热门电影，类型覆盖动作、爱情、喜剧、悬疑、科幻等。' },
  { icon: 'ri-live-line', title: '电视剧资源', desc: '跟踪最新上线的国内外剧集，同步连载进度，提供剧集目录与单集信息展示。' },
  { icon: 'ri-refresh-line', title: '更新策略', desc: '资源每日巡检更新，新作品优先展示于首页焦点图与最新更新板块，热门剧集持续跟进。' },
];

const notices = [
  '本站为前端演示项目，所有影视信息、图片与链接均为演示示例，不提供真实视频播放、下载或在线观看服务。',
  '站内不设置用户账号体系，不收集个人身份信息；收藏功能仅通过浏览器本地存储实现，数据仅保存在你的设备中。',
  '站内所有影视作品的相关权利均归原权利人所有，本站不主张任何权利，如有内容异议请通过下方方式联系我们。',
  '请在符合当地法律法规的前提下浏览本站内容，本演示不构成任何形式的观看或传播建议。',
];

export default function AboutUs() {
  usePageMeta({
    title: '关于我们 - 秋霞电影网',
    description: '了解秋霞电影网的网站定位、内容范围、更新策略、联系方式与使用须知，本站为影视内容浏览演示平台。',
    keywords: '关于秋霞电影网,网站介绍,版权声明,联系方式',
  });

  return (
    <div className="w-full px-4 md:px-8 py-6 md:py-8">
      <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />

      <div className="mt-4 mb-8">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于我们</h1>
        <p className="mt-2 text-sm md:text-base text-foreground-600 max-w-3xl">
          秋霞电影网是一个面向广大影视爱好者的内容浏览平台，专注提供电影与电视剧资源的分类、筛选与检索体验。
        </p>
      </div>

      <section className="rounded-xl bg-primary-950 text-background-100 px-6 md:px-10 py-8 md:py-12 mb-8">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-3">网站定位</h2>
        <p className="text-sm md:text-base leading-loose text-background-200 max-w-4xl">
          我们相信，找到想看的内容不应该是一件麻烦事。秋霞电影网围绕"最新电影电视剧在线观看"的核心需求，
          以清晰的内容分类、便捷的导航结构和及时的更新机制，帮助追剧党与电影爱好者快速定位感兴趣的影视作品。
          无论你想追一部正在连载的热门剧集，还是想找一部高分电影，这里都能提供顺畅的浏览体验。
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
          {[
            { num: '24+', label: '在库影视资源' },
            { num: '6', label: '覆盖地区' },
            { num: '10', label: '类型分类' },
            { num: '每日', label: '内容更新频率' },
          ].map((stat) => (
            <div key={stat.label} className="rounded-lg bg-background-50/10 px-4 py-4">
              <p className="font-heading text-2xl md:text-3xl font-bold text-accent-400">{stat.num}</p>
              <p className="text-xs md:text-sm text-background-200 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-8">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-5">内容范围说明</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {contentScope.map((item) => (
            <div key={item.title} className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6">
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500 text-primary-950 text-2xl mb-4">
                <i className={item.icon}></i>
              </span>
              <h3 className="font-heading font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5 mb-8">
        <div className="rounded-lg bg-accent-100 border border-accent-300 p-5 md:p-6">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
            <i className="ri-customer-service-2-line text-accent-700"></i>联系方式
          </h2>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-primary-700">
                <i className="ri-mail-line"></i>
              </span>
              <span className="text-foreground-800">feedback@qiuxia-demo.com（演示邮箱）</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-primary-700">
                <i className="ri-chat-smile-2-line"></i>
              </span>
              <span className="text-foreground-800">在线反馈表单（演示，暂未开放提交）</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-primary-700">
                <i className="ri-time-line"></i>
              </span>
              <span className="text-foreground-800">服务时间：每日 09:00 - 22:00</span>
            </li>
          </ul>
        </div>

        <div className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
            <i className="ri-shield-check-line text-primary-700"></i>使用须知与版权声明
          </h2>
          <ul className="space-y-3 text-sm text-foreground-600 leading-relaxed">
            {notices.map((notice) => (
              <li key={notice} className="flex gap-2">
                <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-500 mt-2 shrink-0"></i>
                <span>{notice}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}